"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.illustrativeColors = exports.beigeGrisGalet = exports.brownOpera = exports.brownCaramel = exports.brownCafeCreme = exports.orangeTerreBattue = exports.yellowMoutarde = exports.yellowTournesol = exports.pinkTuile = exports.pinkMacaron = exports.purpleGlycine = exports.blueCumulus = exports.blueEcume = exports.greenArchipel = exports.greenMenthe = exports.greenEmeraude = exports.greenBourgeon = exports.greenTilleulVerveine = void 0;
exports.greenTilleulVerveine = 'green-tilleul-verveine';
exports.greenBourgeon = 'green-bourgeon';
exports.greenEmeraude = 'green-emeraude';
exports.greenMenthe = 'green-menthe';
exports.greenArchipel = 'green-archipel';
exports.blueEcume = 'blue-ecume';
exports.blueCumulus = 'blue-cumulus';
exports.purpleGlycine = 'purple-glycine';
exports.pinkMacaron = 'pink-macaron';
exports.pinkTuile = 'pink-tuile';
exports.yellowTournesol = 'yellow-tournesol';
exports.yellowMoutarde = 'yellow-moutarde';
exports.orangeTerreBattue = 'orange-terre-battue';
exports.brownCafeCreme = 'brown-cafe-creme';
exports.brownCaramel = 'brown-caramel';
exports.brownOpera = 'brown-opera';
exports.beigeGrisGalet = 'beige-gris-galet';
exports.illustrativeColors = [
    exports.greenTilleulVerveine,
    exports.greenBourgeon,
    exports.greenEmeraude,
    exports.greenMenthe,
    exports.greenArchipel,
    exports.blueEcume,
    exports.blueCumulus,
    exports.purpleGlycine,
    exports.pinkMacaron,
    exports.pinkTuile,
    exports.yellowTournesol,
    exports.yellowMoutarde,
    exports.orangeTerreBattue,
    exports.brownCafeCreme,
    exports.brownCaramel,
    exports.brownOpera,
    exports.beigeGrisGalet,
];
